import { Methods } from '@newview/infrastructure';
import { basicBaseApi } from "./basicBaseApi";

export class ShareroadtoprojectApi extends basicBaseApi {

  public get ControllerName(): any {
    return 'shareroadtoproject'
  }
  /**
   * 批量保存项目线路关系
   * @param projectDataId 
   * @param params 
   */
  public configRoadForProjectSystem(projectDataId,params){
    return this.send(params,"configRoadForProjectSystem?projectDataId="+projectDataId,Methods.POST)
  }
  /**
   * 子项目id查询绑定的线路列表
   * @param projectDataId 
   */
  public QueryRoadForProjectSystem(projectDataId){
    return this.send({projectDataId:projectDataId},"QueryRoadForProjectSystem",Methods.GET)
  }
  /**
   *  子项目id查询线路列表
   * @param projectDataId 
   * @returns 
   */
  public getRoadInForListByPdId(projectDataId){
    return this.send({projectDataId:projectDataId},"getRoadInForListByPdId",Methods.GET)
  }
  
}